import { AppConfig } from './../../app/app.config';
import { Component, ViewChild } from '@angular/core';
import { SigninService } from '../../services/signin.service';
import { AlertService } from '../../providers/alert.service';
import { SigninPage } from '../signin/signin';
import { NavController } from 'ionic-angular';
import { StorageService } from '../../providers/storage.service';
import { CommonService } from '../../services/common.service';
import { WechatSettingModel } from '../../models/wechat.model';

@Component({
    selector: 'wechat',
    templateUrl: 'wechatregist.html',
    providers: [

    ]
})

export class WechatRegistPage {
    message = "用户注册中...";
    wechatSettings: WechatSettingModel;
    recode: string = "";
    state: string = "";

    constructor(
        private navCtrl: NavController,
        private signinService: SigninService,
        private alert: AlertService,
        private localStorage: StorageService,
        private common: CommonService,
        private appConfig: AppConfig
    ) {
        this.recode = "";
        this.wechatSettings = new WechatSettingModel();
    }

    ionViewDidLoad() {
        this.state = this.common.getParam("state");
        this.recode = this.common.getParam("code");
        this.wechatSettings = this.appConfig.GetWechatSettings();
        if (!this.wechatSettings) {
            this.wechatoAuth();
        } else {
            this.jumpWechatUrl();
        }
    }

    wechatoAuth() {
        this.common.oAuth().then((res: WechatSettingModel) => {
            if (res) {
                this.wechatSettings = res;
                this.localStorage.write("wechatsettings", this.wechatSettings);
            } else {
                this.navCtrl.push(SigninPage);
            }
        }).then(() => {
            this.jumpWechatUrl();
        }).catch((err) => {
            document.getElementById("errorMessage").innerHTML = err;
        })
    }

    jumpWechatUrl() {
        if (!this.state) {
            this.state = new Date().getTime() + "";
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="
                + this.wechatSettings.WxAppID + "&redirect_uri="
                + this.wechatSettings.WapJumpUrl + "&response_type=code&scope=snsapi_userinfo&state="
                + this.state + "#wechat_redirect";
        } else {
            this.wechatRegist(this.recode, this.state);
        }
    }


    wechatRegist(code, state) {
        let link = this.localStorage.readString("registKey");
        this.signinService.getWechatRegisterKey(code, state).then(s => {
            let unionid = s;
            this.weChatRegist(link, unionid);
        }).catch(err => {
            this.message = "获取注册值失败！"
        })
        this.localStorage.remove("registKey");
    }

    weChatRegist(link, unionid) {
        this.signinService.weChatRegister(link, unionid).then(s => {
            if (s.Result) {
                var userInfo = s.Parameter;
                var attr = userInfo.split(",");
                var username = attr[0];
                var password = attr[1];
                this.message = "微信扫描自动注册成功！<br />会员名称: <span class=\"scolor\"> " + username
                    + " </span> ，<br />预设密码： <span class=\"scolor\">" + password
                    + "</span>，<br /> 手机截屏妥善保存您的注册信息! ";

            } else {
                this.alert.alert({
                    title: s.Error,
                    buttons: [{
                        text: "确认",
                        handler: () => {
                            this.navCtrl.push(SigninPage);
                        }
                    }]
                })
            }
        }).catch(err => {
            this.alert.alert({
                title: JSON.parse(err._body).ExceptionMessage,
                buttons: [{
                    text: "确认",
                    handler: () => {
                        this.navCtrl.push(SigninPage);
                    }
                }]
            });
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/wechat/wechatregist.ts